import React, { useEffect, useState } from "react";
import styles from "../../../styles/pages/iaOffering.module.scss";
import Icons from "../../../public/assets/svg";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";


import _get from "lodash/get";
import ReactPlayer from "react-player";

import { LazyLoadImage } from "react-lazy-load-image-component";

import endpoints from "../../../utility/endpoints";

import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


import {
    sessionTimeOutCheck,
    checkExpiry,
  } from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Card from "../../offeringCard";
import PdfViewerModal from "../../pdfModalViewer";

import { useIntersection } from 'react-use';




const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  return (
    <div
    // className="carousel-button-group position-absolute w-100"
    // style={{ top: "345px" }}
    >
      <span
        className={currentSlide === 0 ? styles.customprev : styles.customprev}
        onClick={() => previous()}
      >
        <LazyLoadImage src="/assets/svg/Lefti.png" />
      </span>
      <span className={styles.customnext} onClick={() => next()}>
        <LazyLoadImage src="/assets/svg/righti.png" />
      </span>
    </div>
  );
};

  const responsive3 = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      partialVisibilityGutter: 40,
    },
  };

function index(props) {
 
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })
  
  //console.log(props, "propsatiaofferingsyou");

  const [playing,setPlaying] = useState(false);
  const [pdfModal,setPdfModal] = useState(false);
  const [pdfUrl,setPdfUrl] = useState("");
  const [pdfTitle,setPdfTitle] = useState("");

//console.log(pdfUrl,"pdf_link");

const intersectionRef = React.useRef(null);
  const videoIntersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1
  });
  
  return (

    <>

<div className={styles.heximages}>
      <div className="container">
        
        <div className={`${styles.hexImage}`}>
          <div className={`${styles.imagesAlign} row justify-content-md-around`}>
            <div className={styles.Image}>
            {(_get(props,"data[2].component.content.field_offerings_content",[])).map((item,index)=>
            <>
             { isTabletOrMobile ?  item.field_title == props.title ?
             <>
             
             <Link href = "/offerings">
                 <img src="/assets/svg/cezarrow1.png" className={styles.backarrow} />
              </Link>
              <div className={`${styles.hexCard} ${item.field_title==props.title ? styles.active :null}`}  key={index}>
                <div className={`${styles.hex} ${item.field_title==props.title ? styles.hexactive :null}`}>
                  <div className={styles.border}>
                  <div className = {styles.imgWrapper}>
                    <img src={`${endpoints.drupalIp}${item.field_offerings_image[0].file_url}`} alt="" />
                    </div>
                  </div>
                </div>
                <div className={`${item.field_title==props.title ? styles.span :null}`}>
                <span className = {styles.hexCardText}>{item.field_title}</span>
                </div>
              </div>
             </>
              : null
            :
            <Link href={item.field_title == "Catalogue Products" ? "/catalogue-products"
            :item.field_title == "Touchless Processes" ? "/touchless-processes"
            : item.field_title == "Profile Automation" ? "/profile-automation"
            : item.field_title == "Organic Demand" ? "/organic-demand"
            : item.field_title == "Intelligent Applications" ? "/intelligent-applications" : "/404"}>
             <div className={`${styles.hexCard} ${item.field_title==props.title ? styles.active :null}`}  key={index}>
               <div className={`${styles.hex} ${item.field_title==props.title ? styles.hexactive :null}`}>
                 
                 <div className={styles.border}>
                 <div className = {styles.imgWrapper}>
                   <img src={`${endpoints.drupalIp}${item.field_offerings_image[0].file_url}`} alt="" />
                   </div>
                 </div>
               </div>
               <div className={`${item.field_title==props.title ? styles.span :null}`}>
               <span className={styles.null}>{item.field_title}</span>
               </div>
             </div>
             </Link>
            }
              </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>


    <div className={styles.container}>
        <div className="container">
            <div className={styles.wrapper}>
                <div className={styles.heading}>
                    {_get(props,"title","")}
                </div>
                <div className={styles.description}>
                    {_get(props,"data[0].component.content.field_description_1","")}
                </div>
                <div className={styles.image}>
                    <img src = {`${endpoints.drupalIp}${_get(props,"data[0].component.content.field_offering_image[0].file_url","")}`} 
                    alt ={_get(props,"data[0].component.content.field_offering_image[0].image_alt","")} />
                </div>
                <div className={styles.desc} dangerouslySetInnerHTML={{__html:_get(props,"data[0].component.content.field_description_2","")}}></div>

            </div>
        </div>
    </div>
   {
  //  (props.title==="Profile Automation" || props.title==="No Touch Process" ) &&
   <div className= {styles.videoContainer}>
        <div className="container">
            <div className={styles.videoWrapper}>
                <div className={styles.video} ref={intersectionRef}>
                  <>
                  {intersectionRef !== null &&
                    <ReactPlayer
                      width={isTabletOrMobile ? "100%":"83%"}
                      height= {"100%"}
		                  playing={videoIntersection?.isIntersecting ? true : false}
                      muted={false}
                      loop={true}
                      autoplay
                      controls={true}
                      url={ _get(props,"data[0].component.content.field_video_type","") !="video_url" ?
 endpoints.drupalIp + _get(props,"data[0].component.content.field_offering_video[0].file_url","")
 : _get(props,"data[0].component.content.field_offering_video_link[0].uri","")
 }
                    />
                  }
                  </>
                     {/* <div className={styles.play} onClick={()=>setPlaying(!playing)} style={{
                       opacity: playing ? 0.4 : 1,
                       transition: 'opacity 0.4s ease'
                     }}>
                       {playing ? 
                       <img src ="/assets/svg/pauseVideo.png"  alt ="" height="40px" width="40px"/>
                       :
                       <img src="/assets/svg/playVideo.png" alt="" height="40px" width="40px"/>
                       }
                    </div> */}
                    </div>
                   
                   
               <div className = {styles.videoTextWrapper}>
                <div className={styles.videoTitle}>
                    {_get(props,"data[0].component.content.field_offering_video_title","")}
                </div>
                        
                <div className={styles.download} onClick={()=>window.open(`${endpoints.drupalIp + _get(props,"data[0].component.content.field_offering_video[0].file_url","")}?download`)}>
                    <div className={styles.downloadIcon}>
                    <Icons name="downloadBlue"></Icons>
                    </div>
                    <div className={styles.downloadText}>
                        Download Video
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>}
{/*
    <div className={styles.articleContainer}>
        <div className={`${styles.container} container`}>
           
                <div className={styles.grid}>
                    <div className={styles.imageWrapper}>
                        <div className={styles.img}>
                            <img src={`${endpoints.drupalIp}${_get(props,"data[1].component.content.field_about_offering_component[0].field_about_image[0].file_url","")}`}
                             alt=""/>
                        </div>
                    </div>
               
                    <div className={styles.textWrapper}>
                       <div className={styles.textModal}>
                        <div className={styles.heading}>
                       {_get(props,"data[1].component.content.field_about_offering_component[0].field_title","")}
                        </div>
                        <div className={styles.desc} 
                        dangerouslySetInnerHTML={{__html:_get(props,
                        "data[1].component.content.field_about_offering_component[0].field_about_offering_description",
                        "")}}></div>
                        <div className={styles.downloadButton} onClick= {() => window.open("https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/Offering_Documents/Intelligent%20Automation%20Strategy%20Paper%202022.pdf")}>
                            <span className={styles.text}>
                            {_get(props,"data[1].component.content.field_about_offering_component[0].field_about_button_text","")}
                            </span>
                        </div>
                    </div>
                 </div>
                </div>
            </div>
       
    </div>
  */} 
      {/*  <div className={styles.botstorePage}>
          <div className="container pl-0 pr-0">
            <div className={`${styles.carouselRow}row`}>
              <div className="col-12">
                <p className={styles.head}>
                {_get(props,"data[1].component.content.field_offering_case_studies[0].field_case_study_section_heading","")}
                </p>
                
                
                  <div className={styles.main}>
                    
                  
                    
                      <Carousels
                        partialVisible={true}
                        responsive={responsive3}
                        ssr={true}
                        arrows={false}
                        transitionDuration={0}
                        customButtonGroup={<ButtonGroup />}
                        renderButtonGroupOutside={true}
                        infinite
                        style={{ width: "100%" }}
                      >
                       {(_get(props,"data[1].component.content.field_offering_case_studies[0].field_case_study",[])).map((item, index) => (
                          <div className={styles.botcard}>
                            <Card 
                                key={index}
                                setPdfModal={setPdfModal}
                                setPdfUrl={setPdfUrl}
                                setPdfTitle={setPdfTitle}
                                data={{
                                  field_background_image : `${endpoints.drupalIp}${item.field_offerings_image[0].file_url}`,
                                  field_title: item.field_title,
                                  field_description: item.field_description,
                                  field_link: item.field_know_more_link[0].title,
                                  pdf_link: item.field_know_more_link[0].uri,
                                
                                  
                                }} />
                                
                          </div>
                         
                       )
                       )}


                        
                      </Carousels>
                    
                  </div>
                </div>
               
              
            </div>
          </div>
        </div> */}
          {
            pdfModal ?
             <PdfViewerModal
             setPdfModal={setPdfModal}
             pdfUrl={pdfUrl}
             pdfTitle={pdfTitle}
             />
             :null
          }   
    </>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
